import Phaser from 'phaser';
import { sfx } from '../audio/sfx';
import { loadTitleArt, makeShadowTexture } from '../ui/assets';
import { ensureTitleArt } from '../ui/ensureTextures';
import { ensureHubIcons } from '../ui/hubIcons';
import { installPawTexture } from '../ui/dirtPaint';
import { installDuelMusic } from '../ui/duelMusicPref';
import { installSoundPrefs } from '../ui/soundPrefs';
import { stage } from '../ui/stage';
import { installVolumes } from '../ui/volumePrefs';
import { addText } from '../ui/widgets';
import { addWoodPanel, woodType } from '../ui/woodPanel';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('boot');
  }

  preload(): void {
    const width = 440;
    const y = stage.h / 2;
    const left = (stage.w - width) / 2;
    addWoodPanel(this, left - 16, y - 28, width + 32, 56, 2);
    const fill = this.add.rectangle(left, y, 8, 22, 0xf0c14a).setOrigin(0, 0.5).setDepth(3);
    addText(this, stage.w / 2, y - 64, 'Loading the glen…', woodType('32px')).setOrigin(0.5).setDepth(4);
    this.load.on('progress', (progress: number) => {
      fill.width = Math.max(8, width * progress);
    });
    loadTitleArt(this);
  }

  create(): void {
    installSoundPrefs();
    installDuelMusic();
    installVolumes();
    makeShadowTexture(this);
    sfx.preloadTitle();
    const start = () => {
      this.scene.start('title');
    };
    const fonts = document.fonts;
    Promise.all([
      fonts.load('700 24px Fredoka'),
      fonts.load('700 32px Fredoka'),
      fonts.load('80px "Lilita One"'),
      installPawTexture(this),
      ensureHubIcons(this).then(() => ensureTitleArt(this)),
    ]).then(start, start);
  }
}
